<script>
    import { onMount } from "svelte";

    onMount(async () => {});
    let menu = ["Acceuil", "Labo", "Genius", "Doc", "Art"];
</script>

<div id="blockmenu">
    <!--   {#each menu as item}
        <p class="item">{item}</p>
    {/each} -->
</div>
<div id="blockcache">
    <h1>Bienvenu au.. Genius Lab. !</h1>
</div>

<style>
    @keyframes apparition {
        from {
            opacity: 0%;
        }
        to {
            opacity: 100%;
        }
    }
    #blockmenu {
        position: absolute;
        top: 200px;
        left: 20px;

        border-radius: 5px;
    }
    .item {
        font-size: 21px;
        background-color: rgb(19, 19, 19);
        cursor: url("/img/mouse2.png"), pointer;
        border-radius: 15px;
        color: rgb(255, 255, 255);
        box-shadow: 0px 0px 0px rgb(0, 0, 0), 0px 0px 5px rgb(0, 0, 0) inset;
        padding: 3px;
        text-shadow: 1px 1px 16px rgb(133, 0, 163);
        margin: 10px;
    }
    .item:hover {
        color: rgb(0, 225, 255);
        box-shadow: 0px 0px 0px rgb(0, 0, 0), 0px 0px 5px blueviolet;
    }
    #blockcache {
        border: solid 1px black;
        height: 380px;
        width: 740px;
        position: absolute;
        z-index: 0;
        top: 420px;
        left: 50%;
        transform: translate(-50%, -50%);
        background-color: rgb(9, 9, 9);
        border-radius: 15px;
        box-shadow: 0px 0px 0px rgb(0, 0, 0), 0px 0px 5px blueviolet;
    }
    #blockcache h1 {
        color: rgb(255, 255, 255);
        text-shadow: 1px 1px 16px rgb(133, 0, 163);
        font-size: 30px;
    }
    #blockcache p {
        color: rgb(255, 255, 255);
        margin-top: 35px;
        font-size: 18px;
    }
</style>
